import { z } from 'zod';
import { t } from 'i18next';
import { isValidNum } from '@lili/lili-frontend-common';
import { OnboardingFormFields } from '@Types/index.ts';

export const phoneFormScheme = z.object({
  [OnboardingFormFields.PHONE_NUMBER]: z
    .string()
    .trim()
    .refine((value) => isValidNum(value), { message: t('enErrors:phone') }),
  [OnboardingFormFields.PHONE_NUMBER_VALIDATION_STATUS]: z.boolean(),
});
